module.exports = __webpack_public_path__ + "img/LQC_TC.6b19afd8.jpg";